import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import { onFormChangeUniversal } from './functions/onFormChange';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { TriggerService } from '../../core/trigger/trigger_service';
import { validateFieldUniversal } from './functions/validateField';
import { WActionButton } from '../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

export interface DateneingabeEnergiedatenWaermeProps {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
}

export class DateneingabeEnergiedatenWaerme extends React.Component<DateneingabeEnergiedatenWaermeProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
        this.filterOptions = this.filterOptions.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
        this.preFilter = this.preFilter.bind(this);
        this.validateField = this.validateField.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    filterOptions?(options: Array<any>, key: string, data: any): Array<any> {
        const standort_energietraeger: Array<any> = this.props.data[IDs.ENT_STANDORT_ENERGIETRAEGER] || [];
        const standort_gebaeude: Array<any> = this.props.data[IDs.ENT_GEBAEUDE] || [];
        const { standort_tid } = data;
        const energietraeger: Array<number> = (standort_tid && +standort_tid > 0
            ? standort_energietraeger
                .filter((item: any) => (item.standort_tid_orig || null) === standort_tid)
            : standort_energietraeger)
                .map((item: any) => item.energiedaten_waerme_energietraeger_tid_orig);
        const gebaeude: Array<number> = (standort_tid
            ? standort_gebaeude
                .filter((item: any) => (item.standort_tid_orig || null) === standort_tid)
            : standort_gebaeude)
                .map((item: any) => item.tid);

        switch (key) {
            case 'energietraeger_tid':
                return options && standort_tid && standort_tid > 0
                    ? options
                        .filter((item: any) => (
                            item.tid
                            && energietraeger.length === 0 || energietraeger.indexOf(item.tid) > -1
                        ))
                    : options;
            case 'gebaeude_tid':
                return options
                    ? options.filter((item: any) => item.tid && gebaeude.indexOf(item.tid) > -1)
                    : options;
            default:
                return options;
        }
    }

    onFormChange(WFormData: any): void {
        onFormChangeUniversal(IDs.ENT_ENERGIEDATEN_WAERME, WFormData, this);
    }

    preFilter(data: Array<any>): Array<any> {
        const { standortSelected } = this.props;

        return standortSelected
            ? data.filter((item: any) => (item.standort_tid_orig || null) === standortSelected.tid)
            : data;
    }

    render(): JSX.Element {
        const showGebaeude: boolean = (this.props.data[IDs.ENT_KONFIGURATION] || [])
            .some((param: any) => param.daten_standorte_gebaeude_orig === 1);
        const customFormConfig: any = showGebaeude ? {} : { gebaeude_tid: { hidden: true } };
        const hiddenColumns: Array<string> = showGebaeude ? [] : ['gebaeude_tid'];

        return (
            <WFormsTableWrapper
                entity={IDs.ENT_ENERGIEDATEN_WAERME}
                module={IDs.MOD_ETOOL}
                actions={['add', 'edit', 'delete']}
                externalHeaderElements={[this.renderAuswertungButton()]}
                customClass={'Custom-ETA'}
                formLayout={'flowV2'}
                addLabel={'Wärme erfassen'}
                onFormChange={this.onFormChange}
                preFilterFunction={this.preFilter}
                valueFieldSelectDefaultOptions={{ monat: 'Ganzes Jahr' }}
                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_ENERGIEDATEN_WAERME)}
                filterOptions={this.filterOptions}
                validateField={this.validateField}
                hiddenColumns={hiddenColumns}
                customFormConfig={customFormConfig}
            />
        );
    }

    renderAuswertungButton(): JSX.Element {
        return (
            <WActionButton
                label='Auswertung'
                insideText='Auswertung'
                tooltip='Zum Datenauswertungsbereich springen'
                key='auswertung'
                action='view'
                onAction={() => this.props.onRoutingChange({ path: RoutingIDs.ROUTE_DATENAUSWERTUNG_WAERME })}
            />
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        return validateFieldUniversal(IDs.ENT_ENERGIEDATEN_WAERME, key, value, data, onValueChange, this.props.data);
    }
}
